/**
 * LessonTour — coach-mark walkthrough that plays the first time a member
 * opens a lesson. Uses the same PageTour engine as Dashboard, Learning
 * and Community tours.
 *
 * Targets stable data-testid attributes on the LessonViewer so the tour
 * stays accurate as the page evolves. Each target has a fallback selector
 * so the tour degrades gracefully on lesson pages that hide some sections.
 */
import React from 'react';
import PageTour from './PageTour';

const STEPS = [
  {
    target: '[data-testid="lesson-hero"]',
    title: 'Lesson header',
    body: 'The course, module, and lesson title live here. The Back arrow (top-left) returns you to the course outline.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="lesson-progress"]',
    title: 'Where you are in the module',
    body: 'The pill and progress bar show your position — "Lesson N of M" — so you always know how much is left.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="lesson-disclaimer"]',
    title: 'Content advisory',
    body: 'Freeze drying involves heavy equipment and food safety. This one-line reminder appears on every lesson.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="lesson-family-b-metric"]',
    title: 'At-a-glance metrics',
    body: 'Type, duration, and status. When status flips to Done, this lesson counts toward your module + certificate.',
    placement: 'top',
  },
  {
    target: '[data-testid="lesson-header"]',
    title: 'Title & Mark Complete',
    body: 'Read, watch, then hit Mark Complete when you\'re done. Anti-cheat requires you actually engage with the content first.',
    placement: 'top',
  },
  {
    target: '[data-testid="lesson-mark-complete-btn"]',
    title: 'The green button',
    body: 'This is the button that advances your progress + streak + certificate. If quizzes are gating the module, you\'ll be nudged to take them here.',
    placement: 'top',
  },
  {
    target: '[data-testid="lesson-notes-card"]',
    title: 'Take notes as you go',
    body: 'Every lesson has a Markdown-capable private notepad. The AI Teacher planner reads your notes when recommending next steps.',
    placement: 'top',
  },
  {
    target: '[data-testid="lesson-materials-card"]',
    title: 'Downloadable materials',
    body: 'Cycle sheets, recipe cards, vendor lists — anything referenced in the video is downloadable here.',
    placement: 'top',
  },
];

const LessonTour = ({ forceOpen, onFinish }) => (
  <PageTour
    steps={STEPS}
    storageKey="lesson_tour_seen_v1"
    forceOpen={forceOpen}
    onFinish={onFinish}
  />
);

export default LessonTour;
